<app-zero-state [zeroStateNameText]="'unauthorized'" [showButton]="false" (actionButtonClick)="handleClick()"></app-zero-state>
